/*------------------------------------*\
    MODULES
\*------------------------------------*/
import $ from "jquery";

/*------------------------------------*\
    IMG SLIDE
\*------------------------------------*/
class HomeSlide {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        $(document).scroll(function(){
            var sb = $(window).scrollTop() + $(window).height();
            var e = $(self.elem);
            var pos = e.position();
            var posCalc = pos.top - 100;

            if (posCalc < sb) {
                e.find('.img-slide').addClass('is-scrolled');
            }
        });
    }
}

export default HomeSlide;
